import { inject, Injectable } from '@angular/core';
import { ActionHistory, ActionType } from './analytics.type';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { map } from 'rxjs/operators';
import { cloneDeep } from 'lodash-es';

const HISTORY_DEPTH = 50;

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private readonly router = inject(Router);
  private readonly actionHistory: ActionHistory[] = [];

  constructor() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map((event: NavigationEnd) => event.url),
      )
      .subscribe((url) => {
        this.add({
          actionType: ActionType.ROUTER_NAVIGATION,
          navigationUrl: url,
        });
      });
  }

  add(actionHistory: ActionHistory) {
    if (this.actionHistory.length >= HISTORY_DEPTH) {
      this.actionHistory.shift();
    }
    this.actionHistory.push(actionHistory);
  }

  get history(): ActionHistory[] {
    return cloneDeep(this.actionHistory);
  }
}
